export default __webpack_public_path__ + "media/portrait/logo_nike-ce5fff97.svg";